<template>
  <div>
    <v-navigation-drawer
      v-model="sidebar"
      app
      left
      offset-y
      style="margin-top: 50px;"
      class="hidden-md-and-up"
    >
      <template v-for="item in navItems">
        <v-list-group
          v-if="item.children"
          :key="item.text"
          no-action
          class="caption"
        >
          <template v-slot:activator>
            <v-list-item-icon class="mr-2">
              <v-icon small>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </template>

          <v-list-item
            v-for="child in item.children"
            :key="child.text"
            :to="child.route"
            active-class="blue--text"
            class="caption"
            @click="sidebar = false"
          >
            <v-list-item-icon class="mr-2">
              <v-icon small>{{ child.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ child.text }}</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-item
          v-else
          :key="item.text"
          :to="item.route"
          active-class="blue--text"
          class="caption"
          @click="sidebar = false"
        >
          <v-list-item-icon class="mr-2">
            <v-icon small>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ item.text }}</v-list-item-title>
        </v-list-item>
      </template>
    </v-navigation-drawer>

    <v-app-bar dense dark fixed color="primary">
      <span class="hidden-md-and-up">
        <v-app-bar-nav-icon @click="sidebar = !sidebar"></v-app-bar-nav-icon>
      </span>
  <v-list-item-subtitle @click.stop="goHome()">
    <v-avatar width="50" @click.stop="goHome()">
      <img :src="require(`@/assets/cltts_logo.png`)" @click.stop="goHome()"/>
    </v-avatar>
  <v-span class="caption px-2">Charlotte Tamil Sangam</v-span>
  </v-list-item-subtitle>
      <v-spacer class="hidden-md-and-up"></v-spacer>
      <v-toolbar-title class="text-uppercase">
        <router-link to="/enroll" tag="span" style="cursor: pointer" class="text-h5">
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- Right menu -->
      <v-menu offset-y>
        <template v-slot:activator="{ on }" class="ml-4">
          <div v-on="on" class="d-flex align-center">
      <v-btn text class="pa-1" @click.stop="logoutFromFirebase()">
                <v-icon right>exit_to_app</v-icon>
              </v-btn>
          </div>
        </template>
      </v-menu>
    </v-app-bar>
    <v-app-bar
      dense
      class="hidden-sm-and-down secondary-toolbar mt-12"
      :elevate-on-scroll="true"
      fixed
    >
      <v-toolbar-items>
        <template v-for="item in navItems">
          <v-menu
            v-if="item.children"
            :key="item.text"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                text
                v-bind="attrs"
                :class="{ 'v-btn--active': isMenuActive(item) }"
                :ripple="false"
                v-on="on"
              >
                <span>
                  <v-icon small class="blue--text mr-1">{{ item.icon }}</v-icon>
                </span>
                <span class="mt-1 text-subtitle-2 text-capitalize">{{ item.text }}</span>
                <v-icon small class="ml-1">mdi-chevron-down</v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item
                v-for="child in item.children"
                :key="child.text"
                :to="child.route"
                active-class="blue--text"
              >
                <v-list-item-icon class="mr-2">
                  <v-icon small>{{ child.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ child.text }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-btn
            v-else
            :key="item.text"
            text
            :to="item.route"
            :ripple="false"
          >
            <span>
              <v-icon small class="blue--text mr-1">{{ item.icon }}</v-icon>
            </span>
            <span class="mt-1 text-subtitle-2 text-capitalize">{{ item.text }}</span>
          </v-btn>
        </template>
      </v-toolbar-items><v-spacer></v-spacer>
  <div v-if="this.loggedInUser" class="text-right caption blue--text">
    {{ this.loggedInUser }}
  </div>
    </v-app-bar>
  </div>
</template>

<script>

  export default {
  data: () => ({
    dialog: false,
    sidebar: false,
    user: '',
    menuItems: [
      { text: 'Home', icon: 'mdi-home',  route: 'Enroll'},
      { icon: "exit_to_app", text: "Sign Out", route: "/Signin" }
      ]
    }),
    watch: {
      sidebar: false
    },
    computed: {
      navItems () {
      let items = [
        { text: 'Home', icon: 'mdi-home',  route: '/'},
        { text: 'Events', icon: 'mdi-calendar',  route: 'Events'},
        { text: 'Payments', icon: 'mdi-cash', route: 'PaymentGateway' },
        { text: 'PVSA', icon: 'mdi-medal', route: 'PVSA' },
        { text: 'Financials', icon: 'mdi-cash',  route: 'Financials'},
        {
          text: 'Committee',
          icon: 'mdi-account-group',
          children: [
            { text: 'Main Committee', icon: 'mdi-account-group', route: 'Committee' },
            { text: 'Youth Commitee', icon: 'mdi-run', route: 'YouthCommittee' }
          ]
        },
        {
          text: 'Vaagai Malar',
          icon: 'mdi-book-open-page-variant',
          children: [
            { text: '2026', icon: 'mdi-calendar', route: 'VaagaiMalar2026' }
          ]
        },
        { text: 'QRCode', icon: 'mdi-qrcode', route: 'qrcode' },
        { text: 'PhotoGallery', icon: 'mdi-camera',  route: 'PhotoGallery'},
        { text: 'Member-Login', icon: 'mdi-lock', route: 'Signin'},
        { text: 'Faq', icon: 'mdi-email-outline',  route: 'Faq'},
        { text: 'Mission', icon: 'mdi-eye-settings',  route: 'Mission'},
        { text: 'Sponsors', icon: 'mdi-key', route: 'Sponsors'},
        { text: 'ByLaw', icon: 'mdi-book',  route: 'Documents'}
      ]
      if ((this.loggedInUser ==='SuperAdmin') ) {
        items = [
          { icon: "mdi-account", text: "Profile", route: "/userProfile" },
          { text: 'Permissions', icon: 'mdi-wrench',  route: 'UserManagement'},
          { text: 'Membership', icon: 'mdi-wallet',  route: 'MembershipList'},
          { text: 'MyPrograms', icon: 'mdi-calendar-multiple',  route: 'MyPrograms'},
          { text: 'ProgramSchedule', icon: 'mdi-calendar-clock',  route: 'ProgramSchedule'},
          { text: 'MemberCheckIn', icon: 'mdi-scale-balance',  route: 'EventCheckIn'},
          { text: 'ParticipantCheckIn', icon: 'mdi-food-apple',  route: 'Participant'},
          { text: 'Manage Files', icon: 'mdi-file-lock',  route: 'FileManager'},
          { text: 'Send Email', icon: 'mdi-gmail',  route: 'SendEMail'},
          { text: 'Sponsors', icon: 'mdi-handshake',  route: 'ManageSponsors'},
          { text: 'Gallery', icon: 'mdi-camera-iris',  route: 'ManageGallery'},
          //{ text: 'Volunteers', icon: 'mdi-hand-heart',  route: 'Volunteers'},
          //{ text: 'Subscribers', icon: 'mdi-email',  route: 'Subscribers'},
        ]
      } else if (this.loggedInUser ==='Admin') {
        items = [
          { icon: "mdi-account", text: "Profile", route: "/userProfile" },
          { text: 'Membership', icon: 'mdi-wallet',  route: 'MembershipList'},
          { text: 'MyPrograms', icon: 'mdi-calendar-multiple',  route: 'MyPrograms'},
          { text: 'ProgramSchedule', icon: 'mdi-calendar-clock',  route: 'ProgramSchedule'},
          { text: 'MemberCheckIn', icon: 'mdi-scale-balance',  route: 'EventCheckIn'},
          { text: 'ParticipantCheckIn', icon: 'mdi-food-apple',  route: 'Participant'},
          { text: 'FileManager', icon: 'mdi-file-lock',  route: 'FileManager'},
          { text: 'Sponsors', icon: 'mdi-handshake',  route: 'ManageSponsors'},
          { text: 'Gallery', icon: 'mdi-camera-iris',  route: 'ManageGallery'},
          //{ text: 'Volunteers', icon: 'mdi-hand-heart',  route: 'Volunteers'},
          //{ text: 'Subscribers', icon: 'mdi-email',  route: 'Subscribers'},
        ]
      } if ((this.loggedInUser ==='Member') ) {
        items = [
          { icon: "mdi-account", text: "Profile", route: "/userProfile" },
          { text: 'MyEvents', icon: 'mdi-calendar',  route: 'Events'},
          { text: 'Payments', icon: 'mdi-cash', route: 'PaymentGateway' },
          {
            text: 'Committee',
            icon: 'mdi-account-group',
            children: [
              { text: 'Main Committee', icon: 'mdi-account-group', route: 'Committee' },
              { text: 'Youth Commitee', icon: 'mdi-run', route: 'YouthCommittee' }
            ]
          },
          { text: 'MyQRCode', icon: 'mdi-qrcode', route: 'qrcode' },
          { text: 'Financials', icon: 'mdi-cash',  route: 'Financials'},
          { text: 'Faq', icon: 'mdi-email-outline',  route: 'Faq'},
        ]
      }
      return items
    },
    loggedInUser () {
      var user = this.$store.getters.email
      var role = this.$store.getters.role
      if (user && (role === "SuperAdmin")) return 'SuperAdmin'
      else if (user && (role === "Admin")) return 'Admin'
      else if (user && (role === "Member")) return 'Member'
      else return null
      },
    user () {
      return this.$store.getters.user
      }
    },
    methods: {
      isMenuActive(item) {
        return item.children && item.children.some((child) => this.$route.name === child.route || this.$route.path === `/${child.route}`)
      },
      goHome() {
        this.$router.replace('/')
      },
      logoutFromFirebase() {
      this.$store
        .dispatch('signOutAction')
        .then(() => this.$router.replace('/Signin'))
      },
    },
  }
</script>

<style scoped lang="scss">
::v-deep .v-toolbar__content {
  margin: auto
}

::v-deep .v-toolbar__items > a.v-btn--active {
  .v-btn__content span {
    font-weight: bold
  }
}

::v-deep .v-toolbar__items > a.v-btn--active:after {
  content: "";
  position: absolute;
  left: 18px;
  bottom: 0;
  height: 2px;
  width: 75%;
  border-bottom: 2px solid #32864b
}

::v-deep .secondary-toolbar .v-toolbar__content {
  padding: 0
}

::v-deep .v-btn:before {
  background-color: transparent !important
}
</style>
